module.exports = __webpack_public_path__ + "static/media/aluminio-placa-blanco.f108cbe7.jpg";